import { guardString } from "../strings";
import type { Nullable } from "../types";
import { Constants } from "./constants";

/**
 * A transport leg's display number, e.g. `T000042`.
 *
 * Numbers run per organisation and never per chain: a box crossing four zones collects four
 * numbers, because each hop is its own piece of work somebody accepts and finishes. Reading two
 * consecutive numbers on one box is the ordinary case, not a duplicate.
 */
export function getTransportOrderNumberString(transportOrderNumber: Nullable<string | number>) {
	if (!transportOrderNumber) return guardString(null);

	return [
		Constants.TRANSPORT_ORDER_NUMBER_PREFIX,
		transportOrderNumber.toString().padStart(Constants.TRANSPORT_ORDER_NUMBER_PADDING, "0"),
	].join("");
}
